import * as BasicColor from './BasicColor';

export const COLOR_PRIMARY_010 = BasicColor.BLUE_010;
export const COLOR_PRIMARY_020 = BasicColor.BLUE_020;
export const COLOR_PRIMARY_030 = BasicColor.BLUE_030;
export const COLOR_PRIMARY_040 = BasicColor.BLUE_040;
export const COLOR_PRIMARY_050 = BasicColor.BLUE_050;
export const COLOR_PRIMARY_060 = BasicColor.BLUE_060;
export const COLOR_SECONDARY_010 = BasicColor.SALMON_010;
export const COLOR_SECONDARY_020 = BasicColor.SALMON_020;
export const COLOR_SECONDARY_030 = BasicColor.SALMON_030;
export const COLOR_SECONDARY_040 = BasicColor.SALMON_040;
export const COLOR_SECONDARY_050 = BasicColor.SALMON_050;
export const COLOR_SECONDARY_060 = BasicColor.SALMON_060;
export const COLOR_DYNAMIC_010 = BasicColor.AQUA_010;
export const COLOR_DYNAMIC_020 = BasicColor.AQUA_020;
export const COLOR_DYNAMIC_030 = BasicColor.AQUA_030;
export const COLOR_DYNAMIC_040 = BasicColor.AQUA_040;
export const COLOR_DYNAMIC_050 = BasicColor.AQUA_050;
export const COLOR_DYNAMIC_060 = BasicColor.AQUA_060;
export const COLOR_POSITIVE_010 = BasicColor.GREEN_010;
export const COLOR_POSITIVE_020 = BasicColor.GREEN_020;
export const COLOR_POSITIVE_030 = BasicColor.GREEN_030;
export const COLOR_POSITIVE_040 = BasicColor.GREEN_040;
export const COLOR_POSITIVE_050 = BasicColor.GREEN_050;
export const COLOR_POSITIVE_060 = BasicColor.GREEN_060;
export const COLOR_NEGATIVE_010 = BasicColor.RED_010;
export const COLOR_NEGATIVE_020 = BasicColor.RED_020;
export const COLOR_NEGATIVE_030 = BasicColor.RED_030;
export const COLOR_NEGATIVE_040 = BasicColor.RED_040;
export const COLOR_NEGATIVE_050 = BasicColor.RED_050;
export const COLOR_NEGATIVE_060 = BasicColor.RED_060;
export const COLOR_WARNING_010 = BasicColor.YELLOW_010;
export const COLOR_WARNING_020 = BasicColor.YELLOW_020;
export const COLOR_WARNING_030 = BasicColor.YELLOW_030;
export const COLOR_WARNING_040 = BasicColor.YELLOW_040;
export const COLOR_WARNING_050 = BasicColor.YELLOW_050;
export const COLOR_WARNING_060 = BasicColor.YELLOW_060;
export const COLOR_NEUTRAL_CLEAR = BasicColor.GRAY_CLEAR;
export const COLOR_NEUTRAL_000 = BasicColor.GRAY_000;
export const COLOR_NEUTRAL_010 = BasicColor.GRAY_010;
export const COLOR_NEUTRAL_020 = BasicColor.GRAY_020;
export const COLOR_NEUTRAL_030 = BasicColor.GRAY_030;
export const COLOR_NEUTRAL_040 = BasicColor.GRAY_040;
export const COLOR_NEUTRAL_050 = BasicColor.GRAY_050;
export const COLOR_NEUTRAL_060 = BasicColor.GRAY_060;
export const COLOR_NEUTRAL_070 = BasicColor.GRAY_070;
export const COLOR_NEUTRAL_080 = BasicColor.GRAY_080;
export const COLOR_NEUTRAL_090 = BasicColor.GRAY_090;
export const COLOR_NEUTRAL_100 = BasicColor.GRAY_100;
export const COLOR_NEUTRAL_110 = BasicColor.GRAY_110;
export const COLOR_NEUTRAL_120 = BasicColor.GRAY_120;
export const COLOR_NEUTRAL_130 = BasicColor.GRAY_130;
export const COLOR_AI_010 = BasicColor.PURPLE_010;
export const COLOR_AI_020 = BasicColor.PURPLE_020;
export const COLOR_AI_030 = BasicColor.PURPLE_030;
export const COLOR_AI_040 = BasicColor.PURPLE_040;
export const COLOR_AI_050 = BasicColor.PURPLE_050;
export const COLOR_AI_060 = BasicColor.PURPLE_060;

const GenericColor = {
    COLOR_PRIMARY_010,
    COLOR_PRIMARY_020,
    COLOR_PRIMARY_030,
    COLOR_PRIMARY_040,
    COLOR_PRIMARY_050,
    COLOR_PRIMARY_060,
    COLOR_SECONDARY_010,
    COLOR_SECONDARY_020,
    COLOR_SECONDARY_030,
    COLOR_SECONDARY_040,
    COLOR_SECONDARY_050,
    COLOR_SECONDARY_060,
    COLOR_DYNAMIC_010,
    COLOR_DYNAMIC_020,
    COLOR_DYNAMIC_030,
    COLOR_DYNAMIC_040,
    COLOR_DYNAMIC_050,
    COLOR_DYNAMIC_060,
    COLOR_POSITIVE_010,
    COLOR_POSITIVE_020,
    COLOR_POSITIVE_030,
    COLOR_POSITIVE_040,
    COLOR_POSITIVE_050,
    COLOR_POSITIVE_060,
    COLOR_NEGATIVE_010,
    COLOR_NEGATIVE_020,
    COLOR_NEGATIVE_030,
    COLOR_NEGATIVE_040,
    COLOR_NEGATIVE_050,
    COLOR_NEGATIVE_060,
    COLOR_WARNING_010,
    COLOR_WARNING_020,
    COLOR_WARNING_030,
    COLOR_WARNING_040,
    COLOR_WARNING_050,
    COLOR_WARNING_060,
    COLOR_NEUTRAL_000,
    COLOR_NEUTRAL_010,
    COLOR_NEUTRAL_020,
    COLOR_NEUTRAL_030,
    COLOR_NEUTRAL_040,
    COLOR_NEUTRAL_050,
    COLOR_NEUTRAL_060,
    COLOR_NEUTRAL_070,
    COLOR_NEUTRAL_080,
    COLOR_NEUTRAL_090,
    COLOR_NEUTRAL_100,
    COLOR_NEUTRAL_110,
    COLOR_NEUTRAL_120,
    COLOR_NEUTRAL_130,
    COLOR_NEUTRAL_CLEAR,
    COLOR_AI_010,
    COLOR_AI_020,
    COLOR_AI_030,
    COLOR_AI_040,
    COLOR_AI_050,
    COLOR_AI_060,
};

export default GenericColor;
